import {SampleFilters} from '../SampleFilter';
import filterSample from '../util/filterSample';
import {LegacySamplesSource} from './legacy-add-samples-modal/LegacyAddSamplesModal';

// Use this tool to (re-)filter a set of samples sources, using a narrower filter

export default function filterLegacySampleSources(
  sources: Array<LegacySamplesSource>,
  limitSamplesTo: SampleFilters
): Array<LegacySamplesSource> {
  return sources
    .map((source) => ({
      ...source,
      sampleDetails: source.sampleDetails.filter((sampleDetails) =>
        filterSample(sampleDetails, limitSamplesTo)
      ),
    }))
    .filter((source) => source.sampleDetails.length > 0);
}
